var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loader',{staticClass:"purchase-data",attrs:{"value":_vm.promise}},[_c('div',{staticClass:"container view"},[_c('Card',[_c('DataTable',{attrs:{"sticky":"","theme":"border","value":_vm.items,"columns":[
          { id: 'key', label: 'Key' },
          { id: 'value', label: 'Value' },
        ]},scopedSlots:_vm._u([{key:"key",fn:function({ item }){return [_vm._v(_vm._s(item.key))]}},{key:"value",fn:function({ item }){return [_vm._v(_vm._s(item.value))]}}])})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }